import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

const trackableLinks = document.querySelectorAll<HTMLElement>('[data-analytics-event-category]');

trackableLinks.forEach(link => {
   const category = link.dataset.analyticsEventCategory;
   const eventName = link.dataset.analyticsEventName;
   const customAction = link.dataset.analyticsEventAction;
   link.addEventListener('click', () => {
      trackAnalyticsCustomEvent({
         // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
         eventCategory: category,
         eventAction: customAction || `${category} - Click - ${eventName}`,
      });
   });
});
